import './App.css'
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Toast from './customComponents/Toast'
import { Backdrop, Box } from '@mui/material'
import LoaderIcon from './resources/img/svg/loader.svg'
import { getUserFromLocalStorage } from './utils/utils'
import { Toaster } from 'react-hot-toast'
import ViewTeam from './components/Desktop/Pages/User/Teams/ViewTeam'
import { fetchCartDetails } from './utils/cartSlice'
import { PaymentSuccessPage } from './components/Desktop/Pages/ChecoutPage/PaymentSuccessPage'
import { PaymentFailurePage } from './components/Desktop/Pages/ChecoutPage/PaymentFailurePage'
import LevelCommission from './components/Desktop/Pages/User/MyEarnings/LevelCommission'
import ReferralCommTree from './components/Desktop/Pages/User/MyEarnings/ReferralCommTree'
import NotFound from './components/NotFound'
import LoginAsAdmin from './components/Desktop/Pages/UserRegistration/AdminUserLogin'
import { languageCodes, userBrowserLanguage } from './utils/languageConstants'
import i18next from 'i18next'
import PageSkeleton from './customComponents/Skeleton'
import MobileNonDigitalProductList from './components/Mobile/MobilePages/MobileProductList/NonDigitalProducts/MobileNonDigitalProductList'
import { NavigationProvider } from './routes/NavigationProvider'
import MobilePointsDetails from './components/Desktop/Pages/User/Mystuff/PointsDetails'
import MobileGiftView from './components/Desktop/Pages/User/Mystuff/GiftDetails'
import SponserComm from './components/Desktop/Pages/User/MyEarnings/SponserComm'
import AURComm from './components/Desktop/Pages/User/MyEarnings/AURComm'
import { getPreferredLanguage } from './utils/commonSlice'
import i18n from 'i18next'
import MobilePrtComm from './components/Mobile/User/MobilePages/MobileEarnings/MobilePRTCommission/MobilePrtComm'
import MobilePrtCommInside from './components/Mobile/User/MobilePages/MobileEarnings/MobilePRTCommission/MobilePrtCommInside'
import PrtCommission from './components/Desktop/Pages/User/MyEarnings/PrtCommission'
import PrtCommissonInside from './components/Desktop/Pages/User/MyEarnings/PrtCommissonInside'
import CreateReview from './components/Desktop/Pages/ProductDetails/CreateReview'
import MobileCreateReview from './components/Mobile/MobilePages/MobileReview/MobileCreateReview'

const NonDigitalProductDetails = lazy(() => import('./components/Desktop/Pages/ProductDetails/NonDigitalProductDetails'))

const KycDetailsMain = lazy(() => import('./components/Desktop/Pages/User/MyAccount/KycDetailsMain'))
const BankDetailsMain = lazy(() => import('./components/Desktop/Pages/User/MyAccount/BankDetailsMain'))
const CorporateInfo = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/CorporateInfo'))
const Ourleadership = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/Ourleadership'))
const OurLeadershipInside = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/OurLeadershipInside'))
const LeadershipPrinciples = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/LeadershipPrinciples'))
const Corpresponse = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/Corpresponse'))
const Ethics = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/Ethics'))
const Career = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/Career'))
const LatestUpdates = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/LatestUpdates'))
const PressRelease = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/PressRelease'))
const WorkWithus = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Aboutus/WorkWithus'))
const FooterTestimonials = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Testimonials/FooterTestimonials'))
const FooterBrands = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Brands/FooterBrands'))
const WebsitePolicy = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Policies/WebsitePolicy'))
const FooterSeller = lazy(() => import('./components/Desktop/GlobalComponents/Footer/FooterSeller/FooterSeller'))
const TermsCondistions = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Policies/TermsCondistions'))
const ShippingPolicy = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Policies/ShippingPolicy'))
const RefundCancellation = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Policies/RefundCancellation'))
const FooterContact = lazy(() => import('./components/Desktop/GlobalComponents/Footer/FooterContact/FooterContact'))
const DiversityEquity = lazy(() => import('./components/Desktop/GlobalComponents/Footer/OurWorkPlace/DiversityEquity'))
const OurEmployees = lazy(() => import('./components/Desktop/GlobalComponents/Footer/OurWorkPlace/OurEmployees'))
const EmployeeBenifits = lazy(() => import('./components/Desktop/GlobalComponents/Footer/OurWorkPlace/EmployeeBenifits'))
const PersonalDetailsMain = lazy(() => import('./components/Desktop/Pages/User/MyAccount/PersonalDetailsMain'))
const UserLayout = lazy(() => import('./Layouts/UserLayout'))
const EcomLayout = lazy(() => import('./Layouts/EcomLayout'))
const LandingPage = lazy(() => import('./components/Desktop/Pages/LandingPage/LandingPage'))
const UserSignup = lazy(() => import('./components/Desktop/Pages/UserRegistration/UserSignup'))
const UserSignin = lazy(() => import('./components/Desktop/Pages/UserRegistration/UserSignin'))
const UserForgotPassword = lazy(() => import('./components/Desktop/Pages/UserRegistration/UserForgotPassword'))
const SellerSignup = lazy(() => import('./components/Desktop/Pages/SellerRegistration/SellerSignup'))
const SellerSignIn = lazy(() => import('./components/Desktop/Pages/SellerRegistration/SellerSignIn'))
const SellerForgotPassword = lazy(() => import('./components/Desktop/Pages/SellerRegistration/SellerForgotPassword'))
const CheckoutPage = lazy(() => import('./components/Desktop/Pages/ChecoutPage/CheckoutPage'))
const ProductListingCategories = lazy(() => import('./components/Desktop/Pages/ProductListing/Categories/ProductListingCategories'))
const SubCategories = lazy(() => import('./components/Desktop/Pages/ProductListing/SubCategories/SubCategories'))
const ChildCategories = lazy(() => import('./components/Desktop/Pages/ProductListing/ChildCategories/ChildCategories'))
const ProductDetails = lazy(() => import('./components/Desktop/Pages/ProductDetails/ProductDetails'))
const Cart = lazy(() => import('./components/Desktop/Pages/Cart/Cart'))
const MobileHompage = lazy(() => import('./components/Mobile/MobilePages/MobileHomePage/MobileHompage'))
const MobileCategoriesPage = lazy(() => import('./components/Mobile/MobilePages/MobileCategories/MobileCategoriesPage'))
const MobileProductList = lazy(() => import('./components/Mobile/MobilePages/MobileProductList/MobileProductList'))
const MobileProductDetail = lazy(() => import('./components/Mobile/MobilePages/MobileProductDetailPage/MobileProductDetail'))
const MobileCart = lazy(() => import('./components/Mobile/MobilePages/MobileCartPage/MobileCart'))
const MobileCheckout = lazy(() => import('./components/Mobile/MobilePages/MobileCheckout/MobileCheckout'))
const MobileWishlist = lazy(() => import('./components/Mobile/MobilePages/MobileWishList/MobileWishlist'))
const Footer = lazy(() => import('./components/Desktop/GlobalComponents/Footer/Footer'))
const GameCart = lazy(() => import('./components/Desktop/Pages/Cart/GameCart'))
// USER IMPORTS
const PersonalDetailsORG = lazy(() => import('./components/Desktop/Pages/User/MyAccount/PersonalDetailsORG'))
const ChangePassword = lazy(() => import('./components/Desktop/Pages/User/MyAccount/ChangePassword'))
const ChangeTransactionPassword = lazy(() => import('./components/Desktop/Pages/User/MyAccount/ChangeTransactionPassword'))
const Address = lazy(() => import('./components/Desktop/Pages/User/ManageAddress/Address'))
const AddAddress = lazy(() => import('./components/Desktop/Pages/User/ManageAddress/AddAddress'))
const SponsoredTeam = lazy(() => import('./components/Desktop/Pages/User/Teams/SponsoredTeam'))
const ProductTeam = lazy(() => import('./components/Desktop/Pages/User/Teams/ProductTeam'))
const Orders = lazy(() => import('./components/Desktop/Pages/User/Orders/Orders'))
const Points = lazy(() => import('./components/Desktop/Pages/User/Mystuff/Points'))
const ShoppingEgift = lazy(() => import('./components/Desktop/Pages/User/Mystuff/ShoppingEgift'))
const MobilegamesInside = lazy(() => import('./components/Mobile/User/MobilePages/MobileGames/MobilegamesInside'))
const Salarcoins = lazy(() => import('./components/Desktop/Pages/User/Mystuff/Salarcoins'))
const GcTeamView = lazy(() => import('./components/Desktop/Pages/User/MyEarnings/GcTeamView'))
const ReferralComm = lazy(() => import('./components/Desktop/Pages/User/MyEarnings/ReferralComm'))
const Gifts = lazy(() => import('./components/Desktop/Pages/User/Mystuff/Gifts'))
const ShoppingAmount = lazy(() => import('./components/Desktop/Pages/User/Mystuff/ShoppingAmount'))
const SponsorCommission = lazy(() => import('./components/Desktop/Pages/User/MyEarnings/SponsorCommission'))
const Portfolio = lazy(() => import('./components/Desktop/Pages/User/Portfolio/Portfolio'))
const AurCommission = lazy(() => import('./components/Desktop/Pages/User/MyEarnings/AurCommission'))
const SalarPay = lazy(() => import('./components/Desktop/Pages/User/MyWallet/SalarPay'))
const FundTransfer = lazy(() => import('./components/Desktop/Pages/User/MyWallet/FundTransfer'))
const CreditorDebit = lazy(() => import('./components/Desktop/Pages/User/MyWallet/CreditorDebit'))
const RecievedFunds = lazy(() => import('./components/Desktop/Pages/User/MyWallet/RecievedFunds'))
const FundTransferHistory = lazy(() => import('./components/Desktop/Pages/User/MyWallet/FundTransferHistory'))
const WithdrawlRequest = lazy(() => import('./components/Desktop/Pages/User/Withdrawl/WithdrawlRequest'))
const WithdrawlHistory = lazy(() => import('./components/Desktop/Pages/User/Withdrawl/WithdrawlHistory'))
const BankAccVerifications = lazy(() => import('./components/Desktop/Pages/User/Withdrawl/BankAccVerifications'))
const Tickets = lazy(() => import('./components/Desktop/Pages/User/Tickets/Tickets'))
const CreateTicket = lazy(() => import('./components/Desktop/Pages/User/Tickets/CreateTicket'))
const Testimonials = lazy(() => import('./components/Desktop/Pages/User/Testimonials/Testimonials'))
const Createtestimonial = lazy(() => import('./components/Desktop/Pages/User/Testimonials/Createtestimonial'))
const Games = lazy(() => import('./components/Desktop/Pages/User/Games/Games'))
const PlayGames = lazy(() => import('./components/Desktop/Pages/User/Games/PlayGames'))
const MobileProductLevelTeam = lazy(() => import('./components/Mobile/User/MobilePages/MobileTeams/MobileProductLevelTeam'))
const MobileOrderDetail = lazy(() => import('./components/Mobile/User/MobilePages/MobileOrders/MobileOrderDetail'))
const MobilePointDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobilePoints/MobilePointDetails'))
const MobileSalarCoins = lazy(() => import('./components/Mobile/User/MobilePages/MobileSalarCoins/MobileSalarCoins'))
const MobileSalarCoinDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobileSalarCoins/MobileSalarCoinDetails'))
const MobileGiftDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobileGifts/MobileGiftDetails'))
const MobileShoppingAmountDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobileShopping/MobileShoppingAmountDetails'))
const MobileShoppingAmount = lazy(() => import('./components/Mobile/User/MobilePages/MobileShopping/MobileShoppingAmount'))
// const MobileAurComm = lazy(() => import('./components/Mobile/User/MobilePages/MobileEarnings/MobileAurCommission/MobileReferralComm'))
const MobileSponsorCommission = lazy(() =>
	import('./components/Mobile/User/MobilePages/MobileEarnings/MobileSponsorCommission/MobileSponsorCommission')
)
const MobileGameCommission = lazy(() => import('./components/Mobile/User/MobilePages/MobileEarnings/MobileGameCommission/MobileGameCommission'))
const MobileGameCommissionDetails = lazy(() =>
	import('./components/Mobile/User/MobilePages/MobileEarnings/MobileGameCommission/MobileGameCommissionDetails')
)
const MobileGameCommissionTeam = lazy(() =>
	import('./components/Mobile/User/MobilePages/MobileEarnings/MobileGameCommission/MobileGameCommissionTeam')
)
const MobileFundTransferHistoryDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobileWallet/MobileFundTransferHistoryDetails'))
const MobileWithdrawHistoryDetail = lazy(() => import('./components/Mobile/User/MobilePages/MobileWithdrawl/MobileWithdrawHistoryDetail'))
const MobileAddTestimonials = lazy(() => import('./components/Mobile/User/MobilePages/MobileTestimonials/MobileAddTestimonials'))
const MobileRecieveFundsDetails = lazy(() => import('./components/Mobile/User/MobilePages/MobileWallet/MobileRecieveFundsDetails'))
const MobileAddTickets = lazy(() => import('./components/Mobile/User/MobilePages/MobileTickets/MobileAddTickets'))
const Dashboard = lazy(() => import('./components/Desktop/GlobalComponents/User/Dashboard/Dashboard'))

// Component to select layout based on route
const LayoutSelector = ({ children }) => {
	const location = useLocation()
	const isUserRoute = location.pathname.startsWith('/user')

	return isUserRoute ? <UserLayout>{children}</UserLayout> : <EcomLayout>{children}</EcomLayout>
}
const App = () => {
	const { isLoading, showToast, title, message, status } = useSelector((store) => store.toast)
	const { preferredLanguage } = useSelector((state) => state.login)
	const [viewToast, setViewToast] = useState(false)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getPreferredLanguage())
		if (preferredLanguage) {
			localStorage.setItem('i18nextLng', preferredLanguage)
			i18n.changeLanguage(preferredLanguage)
		}
	}, [preferredLanguage])

	useEffect(() => {
		setViewToast(showToast)
	}, [showToast])

	const loder = (
		<Box>
			<Backdrop
				style={{ zIndex: 99999 }}
				classes={{
					root: 'MuiBackdrop-root-loader',
				}}
				open={true}
			>
				<img src={LoaderIcon} alt='Loading...' style={{ width: '250px', height: '250px' }} />
			</Backdrop>
		</Box>
	)
	const user = getUserFromLocalStorage()

	const usersBrowserlanguage = languageCodes?.find((lag) => lag.standardCodes.includes(userBrowserLanguage()))?.code

	// Select the language code to be used (from stored preference, user's language, or default to 'en')
	const code = usersBrowserlanguage || 'en'

	// Update the language in i18next when the code changes
	useEffect(() => {
		// Change the language in the i18next library
		i18next.changeLanguage(code)
	}, [code])

	// Check if the user is authenticated
	const isAuthenticated = !!user

	return (
		<Suspense fallback={<PageSkeleton />}>
			<BrowserRouter>
				<NavigationProvider>
					<Toaster
						position='top-center'
						reverseOrder={false}
						toastOptions={{
							duration: 4000,
						}}
					/>
					{/* <BackNavigationHandler /> */}
					<LayoutSelector>
						<Routes>
							{/* Protect /UserSignup and /UserSignin routes */}
							<Route path='/UserSignup' element={isAuthenticated ? <Navigate to='/' /> : <UserSignup />} />
							<Route path='/UserSignin' element={isAuthenticated ? <Navigate to='/' /> : <UserSignin />} />
							<Route path='*' element={<NotFound />} />
							<Route path='/' element={<LandingPage user={user} />} />
							<Route path='/Footer' exact={true} element={<Footer />} />
							<Route path='/paymentSuccessfull' exact={true} element={<PaymentSuccessPage user={user} />} />
							<Route path='/paymentFailed' exact={true} element={<PaymentFailurePage user={user} />} />
							<Route path='/login-as-admin/:token/:sponserId' exact={true} element={<LoginAsAdmin />} />
							<Route path='/UserSignup' exact={true} element={<UserSignup />} />
							<Route path='/UserSignin' element={<UserSignin />} />
							<Route path='/SellerSignup' exact={true} element={<SellerSignup />} />
							<Route path='/SellerSignIn' exact={true} element={<SellerSignIn />} />
							<Route path='/SellerForgotPassword' exact={true} element={<SellerForgotPassword />} />
							<Route path='/UserForgotPassword' exact={true} element={<UserForgotPassword />} />
							<Route path='/CheckoutPage' exact={true} element={<CheckoutPage />} />
							<Route path='/ProductListingCategories/:categoryId' exact={true} element={<ProductListingCategories user={user} />} />
							<Route path='/SubCategories/:id' exact={true} element={<SubCategories />} />
							<Route path='/ChildCategories/:category' exact={true} element={<ChildCategories user={user} />} />
							<Route path='/ProductDetails/:customUrl' exact={true} element={<ProductDetails user={user} />} />
							<Route path='/non-digital-product-details/:productId' exact={true} element={<NonDigitalProductDetails user={user} />} />
							<Route path='/Cart' exact={true} element={<Cart user={user} />} />
							<Route path='/CreateReview/:productId/:isGame' exact={true} element={<CreateReview user={user} />} />
							<Route path='/GameCart' exact={true} element={<GameCart />} />
							<Route path='/MobileHompage' exact={true} element={<MobileHompage />} />
							<Route path='/MobileCategoriesPage' exact={true} element={<MobileCategoriesPage user={user} />} />
							<Route path='/MobileProductList' exact={true} element={<MobileProductList user={user} />} />
							<Route
								path='/mobileNonDigialProductList/:categoryId'
								exact={true}
								element={<MobileNonDigitalProductList user={user} />}
							/>
							<Route path='/MobileProductDetail/:customUrl' exact={true} element={<MobileProductDetail user={user} />} />
							<Route path='/MobileCart' exact={true} element={<MobileCart />} />
							<Route path='/MobileCreateReview' exact={true} element={<MobileCreateReview />} />
							<Route path='/MobileCheckout' exact={true} element={<MobileCheckout />} />
							<Route path='/MobileWishlist' exact={true} element={<MobileWishlist />} />
							{/* New Routes Added In Merger start */}
							<Route path='/CorporateInfo' exact={true} element={<CorporateInfo />} />
							<Route path='/Ourleadership' exact={true} element={<Ourleadership />} />
							<Route path='/OurLeadershipInside' exact={true} element={<OurLeadershipInside />} />
							<Route path='/LeadershipPrinciples' exact={true} element={<LeadershipPrinciples />} />
							<Route path='/Corpresponse' exact={true} element={<Corpresponse />} />
							<Route path='/Ethics' exact={true} element={<Ethics />} />
							<Route path='/Career' exact={true} element={<Career />} />
							<Route path='/LatestUpdates' exact={true} element={<LatestUpdates />} />
							<Route path='/PressRelease' exact={true} element={<PressRelease />} />
							<Route path='/WorkWithus' exact={true} element={<WorkWithus />} />
							<Route path='/FooterBrands' exact={true} element={<FooterBrands />} />
							<Route path='/FooterContact' exact={true} element={<FooterContact />} />
							<Route path='/FooterSeller' exact={true} element={<FooterSeller />} />
							<Route path='/DiversityEquity' exact={true} element={<DiversityEquity />} />
							<Route path='/OurEmployees' exact={true} element={<OurEmployees />} />
							<Route path='/EmployeeBenifits' exact={true} element={<EmployeeBenifits />} />
							<Route path='/RefundCancellation' exact={true} element={<RefundCancellation />} />
							<Route path='/ShippingPolicy' exact={true} element={<ShippingPolicy />} />
							<Route path='/TermsCondistions' exact={true} element={<TermsCondistions />} />
							<Route path='/WebsitePolicy' exact={true} element={<WebsitePolicy />} />
							<Route path='/FooterTestimonials' exact={true} element={<FooterTestimonials />} />
							{/* New Routes Added In Merger end */}
							{/* USER ROUTE STARTS */}
							<Route path='/user/Dashboard' exact={true} element={<Dashboard user={user} />} />
							<Route path='/user/bankDetails' exact={true} element={<BankDetailsMain user={user} />} />
							<Route path='/user/PrtCommission' exact={true} element={<PrtCommission />} />
							<Route path='/user/PrtCommissonInside/:month' exact={true} element={<PrtCommissonInside />} />
							<Route path='/user/PersonalDetails' exact={true} element={<PersonalDetailsMain user={user} />} />
							<Route path='/user/PersonalDetailsORG' exact={true} element={<PersonalDetailsORG />} />
							<Route path='/user/KycDetails' exact={true} element={<KycDetailsMain user={user} />} />
							<Route path='/user/ChangePassword' exact={true} element={<ChangePassword />} />
							<Route path='/user/ChangeTransactionPassword' exact={true} element={<ChangeTransactionPassword />} />
							<Route path='/user/Address' exact={true} element={<Address user={user} />} />
							<Route path='/user/AddAddress' exact={true} element={<AddAddress />} />
							<Route path='/user/SponsoredTeam' exact={true} element={<SponsoredTeam />} />
							<Route path='/user/ProductTeam' exact={true} element={<ProductTeam />} />
							<Route path='/user/ViewTeam/:level' exact={true} element={<ViewTeam />} />
							<Route path='/user/Orders' exact={true} element={<Orders />} />
							<Route path='/user/Points' exact={true} element={<Points />} />
							<Route path='/user/PointsDetails' exact={true} element={<MobilePointsDetails />} />
							<Route path='/user/Salarcoins' exact={true} element={<Salarcoins />} />
							<Route path='/user/Gifts' exact={true} element={<Gifts />} />
							<Route path='/user/GiftDetails' exact={true} element={<MobileGiftView />} />
							<Route path='/user/ShoppingAmount' exact={true} element={<ShoppingAmount />} />
							<Route path='/user/ReferralComm' exact={true} element={<ReferralComm />} />
							<Route path='/user/SponserComm' exact={true} element={<SponserComm />} />
							<Route path='/user/AUSComm' exact={true} element={<AURComm />} />
							<Route path='/user/GcTeamView/:orderId' exact={true} element={<GcTeamView />} />
							<Route path='/user/SponsorCommission' exact={true} element={<SponsorCommission />} />
							<Route path='/user/LevelCommission/:level' exact={true} element={<LevelCommission />} />
							<Route path='/user/referralCommTree/:orderId' exact={true} element={<ReferralCommTree />} />
							<Route path='/user/Portfolio' exact={true} element={<Portfolio />} />
							<Route path='/user/AurCommission' exact={true} element={<AurCommission />} />
							<Route path='/user/SalarPay' exact={true} element={<SalarPay />} />
							<Route path='/user/FundTransfer' exact={true} element={<FundTransfer />} />
							<Route path='/user/CreditorDebit' exact={true} element={<CreditorDebit />} />
							<Route path='/user/RecievedFunds' exact={true} element={<RecievedFunds />} />
							<Route path='/user/FundTransferHistory' exact={true} element={<FundTransferHistory />} />
							<Route path='/user/WithdrawlRequest' exact={true} element={<WithdrawlRequest user={user} />} />
							<Route path='/user/WithdrawlHistory' exact={true} element={<WithdrawlHistory />} />
							<Route path='/user/bankAccVerifications' exact={true} element={<BankAccVerifications />} />
							<Route path='/user/Tickets' exact={true} element={<Tickets />} />
							<Route path='/user/CreateTicket' exact={true} element={<CreateTicket />} />
							<Route path='/user/Testimonials' exact={true} element={<Testimonials />} />
							<Route path='/user/Createtestimonial' exact={true} element={<Createtestimonial />} />
							<Route path='/user/Games' exact={true} element={<Games />} />
							<Route path='/user/PlayGames/:gameId' exact={true} element={<PlayGames />} />
							{/* Mobile routes */}
							<Route path='/user/MobileProductLevelTeam' exact={true} element={<MobileProductLevelTeam />} />
							<Route path='/user/MobileOrderDetail/:id/:productId' exact={true} element={<MobileOrderDetail />} />
							<Route path='/user/MobilePointDetails' exact={true} element={<MobilePointDetails />} />
							<Route path='/user/MobileSalarCoins' exact={true} element={<MobileSalarCoins />} />
							<Route path='/user/MobileSalarCoinDetails' exact={true} element={<MobileSalarCoinDetails />} />
							<Route path='/user/MobileGiftDetails' exact={true} element={<MobileGiftDetails />} />
							<Route path='/user/MobileShoppingAmount' exact={true} element={<MobileShoppingAmount />} />
							<Route path='/user/MobileShoppingAmountDetails' exact={true} element={<MobileShoppingAmountDetails />} />
							<Route path='/user/MobileSponsorCommission' exact={true} element={<MobileSponsorCommission />} />
							<Route path='/user/MobileGameCommission' exact={true} element={<MobileGameCommission />} />
							<Route path='/user/MobileGameCommissionDetails' exact={true} element={<MobileGameCommissionDetails />} />
							<Route path='/user/MobilePrtComm' exact={true} element={<MobilePrtComm />} />
							<Route path='/user/MobilePrtCommInside/:month' exact={true} element={<MobilePrtCommInside />} />
							<Route path='/user/MobileGameCommissionTeam' exact={true} element={<MobileGameCommissionTeam />} />
							<Route path='/user/MobileRecieveFundsDetails' exact={true} element={<MobileRecieveFundsDetails />} />
							<Route path='/user/MobileFundTransferHistoryDetails' exact={true} element={<MobileFundTransferHistoryDetails />} />
							<Route path='/user/MobileWithdrawHistoryDetail' exact={true} element={<MobileWithdrawHistoryDetail />} />
							<Route path='/user/MobileAddTickets' exact={true} element={<MobileAddTickets />} />
							<Route path='/user/MobileAddTestimonials' exact={true} element={<MobileAddTestimonials />} />
							<Route path='/user/MobilegamesInside/:gameId' exact={true} element={<MobilegamesInside />} />
							<Route path='/user/ShoppingEgift' exact={true} element={<ShoppingEgift />} />
						</Routes>
					</LayoutSelector>
				</NavigationProvider>
			</BrowserRouter>
			{viewToast && <Toast status={status} message={message} title={title} setViewToast={setViewToast} />}
			{isLoading && loder}
		</Suspense>
	)
}

export default App
